import loadable from "@loadable/component";

export const IntegratedLegalBannerDisclaimer = loadable(async () => {
    const component = await import(
        /* webpackChunkName: "integrated-legal-banner-disclaimer-toyota" */
        /* webpackPreFetch: true */
        "./LegalBannerDisclaimer"
    );
    return component.default;
});
